import { UserResponse } from '@shared/models/user';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '../stores/authStore';

const USER_QUERY_KEY = ['me'];

interface UseUserDataOptions {
  revalidateOnMount?: boolean;
  staleTime?: number;
}
export const useUserData = (options: UseUserDataOptions = {}) => {
  const { token, setUser, setTeam, setRole, setSettings } = useAuthStore();
  const queryClient = useQueryClient();

  const {
    revalidateOnMount = false,
    staleTime = 1000 * 60 * 5, // 5 minutos por defecto
  } = options;

  const query = useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: async () => {
      const response = await apiClientWH.get<any>('/me');
      // 🎯 Guardar user, team, role y settings en el store
      setUser(response.data.user);
      setTeam(response.data.team);
      setRole(response.data.role);
      // Los settings vienen en la raíz de la respuesta
      if (response.data.settings) {
        setSettings(response.data.settings);
      }
      return response.data;
    },
    enabled: !!token,
    staleTime: staleTime,
    refetchOnMount: revalidateOnMount,
    refetchOnWindowFocus: false,
  });
  const refreshUserData = () => {
    return queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY });
  };

  return {
    ...query,
    refreshUserData,
  };
};
